<script>
export default {
  name: "app-footer",
  components: {},
  props: {},
  data: () => ({
    rand: new Date().getTime(),
  }),
}
</script>
<template>
  <v-footer
    app
    absolute
    class="d-flex align-center justify-center transparent text-right mt-10"
  >
    <span class="ml-auto primary--text text-body-2"
      >SOLParser ©{{ new Date().getUTCFullYear() }}</span
    >
    <a :href="`/?r=${rand}`" class="ml-auto">
      <span class="primary--text text-caption">2.0.3</span>
    </a>
  </v-footer>
</template>
